class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.currentIndex = 0;
    this.interval = null;
    this.resetTimer = null;
    this.touchStartX = 0;
    this.touchEndX = 0;

    this.goTo = this.goTo.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.start = this.start.bind(this);
    this.stop = this.stop.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.hideForOneDay = this.hideForOneDay.bind(this);
  }

  connectedCallback() {
    this.mode = this.dataset.mode || "static";
    this.intervalMs = Number(this.dataset.interval || 5000);
    this.track = this.querySelector("[data-announcement-track]");
    this.track?.querySelectorAll("[data-announcement-clone]").forEach((clone) => clone.remove());
    this.slides = Array.from(this.querySelectorAll("[data-announcement-slide]"));
    this.previousButton = this.querySelector("[data-announcement-prev]");
    this.nextButton = this.querySelector("[data-announcement-next]");
    this.closeButton = this.querySelector(".wt-announcement__close");

    this.closeButton?.addEventListener("click", this.hideForOneDay);
    this.previousButton?.addEventListener("click", this.previous);
    this.nextButton?.addEventListener("click", this.next);

    if (this.mode === "auto_slide" && this.slides.length > 1 && this.track) {
      const firstClone = this.slides[0].cloneNode(true);
      firstClone.setAttribute("aria-hidden", "true");
      firstClone.setAttribute("data-announcement-clone", "");
      firstClone.removeAttribute("data-announcement-slide");
      this.track.appendChild(firstClone);
    }

    if (this.isSlideMode()) {
      this.track?.addEventListener("touchstart", this.handleTouchStart, { passive: true });
      this.track?.addEventListener("touchmove", this.handleTouchMove, { passive: true });
      this.track?.addEventListener("touchend", this.handleTouchEnd, { passive: true });
      this.addEventListener("mouseenter", this.stop);
      this.addEventListener("mouseleave", this.start);
      this.goTo(0);
      this.start();
    }
  }

  disconnectedCallback() {
    this.stop();
    if (this.resetTimer) {
      clearTimeout(this.resetTimer);
      this.resetTimer = null;
    }
    this.closeButton?.removeEventListener("click", this.hideForOneDay);
    this.previousButton?.removeEventListener("click", this.previous);
    this.nextButton?.removeEventListener("click", this.next);
    this.track?.removeEventListener("touchstart", this.handleTouchStart);
    this.track?.removeEventListener("touchmove", this.handleTouchMove);
    this.track?.removeEventListener("touchend", this.handleTouchEnd);
    this.removeEventListener("mouseenter", this.stop);
    this.removeEventListener("mouseleave", this.start);
  }

  isSlideMode() {
    return (this.mode === "auto_slide" || this.mode === "manual_slide") && this.slides.length > 1;
  }

  start() {
    if (this.mode !== "auto_slide" || this.slides.length < 2) return;
    this.stop();
    this.interval = setInterval(this.next, this.intervalMs);
  }

  stop() {
    if (!this.interval) return;
    clearInterval(this.interval);
    this.interval = null;
  }

  goTo(index) {
    if (!this.track || !this.slides.length) return;
    this.currentIndex = (index + this.slides.length) % this.slides.length;
    this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
  }

  next() {
    if (this.mode === "auto_slide") {
      this.goToAutoNext();
      return;
    }

    this.goTo(this.currentIndex + 1);
  }

  goToAutoNext() {
    if (!this.track || !this.slides.length) return;

    this.currentIndex += 1;
    this.track.style.transition = "transform 0.45s ease";
    this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;

    if (this.currentIndex === this.slides.length) {
      this.resetTimer = window.setTimeout(() => {
        this.track.style.transition = "none";
        this.currentIndex = 0;
        this.track.style.transform = "translateX(0)";
        this.resetTimer = null;

        window.setTimeout(() => {
          this.track.style.transition = "";
        }, 20);
      }, 460);
    }
  }

  previous() {
    if (this.mode === "auto_slide") return;
    this.goTo(this.currentIndex - 1);
  }

  handleTouchStart(event) {
    this.touchStartX = event.touches[0].clientX;
    this.touchEndX = this.touchStartX;
    this.stop();
  }

  handleTouchMove(event) {
    this.touchEndX = event.touches[0].clientX;
  }

  handleTouchEnd() {
    const threshold = 30;
    const distance = this.touchEndX - this.touchStartX;

    if (Math.abs(distance) > threshold) {
      if (distance < 0) this.next();
      else this.previous();
    }

    this.start();
  }

  hideForOneDay() {
    const oneDayLater = new Date().getTime() + 24 * 60 * 60 * 1000;
    localStorage.setItem("wt-announcement-hidden", oneDayLater);
    this.style.display = "none";
  }
}

if (!customElements.get("announcement-bar")) {
  customElements.define("announcement-bar", AnnouncementBar);
}
